"use strict";exports.__esModule=!0,exports.getCurView=getCurView;/**
 * 获取当前 view
 * @param ctx 
 * @returns 
 */function getCurView(a){var b=a.getViews();if(b&&b.length)return b[b.length-1]}